import { Certificate, getOrganizationLogo } from '@revenuemarket/bank';
import { Tooltip } from '@revenuemarket/ui';
import Image from 'next/image';

interface Props {
  certificate: Certificate;
}

const BankListRenderer: React.FC<Props> = ({ certificate }) => {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {certificate.organizationList
        .filter((org) => org.organizationType === 'BK')
        .map((org) => {
          return (
            <div key={`bank-icon-${org.organizationCode}`}>
              <button
                style={{
                  backgroundColor: 'transparent',
                }}
                data-tip
                data-for={`certificate-bank-${org.organizationCode}`}
              >
                <Image
                  key={org.id}
                  src={getOrganizationLogo(org.organizationCode)?.x2}
                  alt={org.organizationCode}
                  width={24}
                  height={24}
                />
              </button>
              <Tooltip
                id={`certificate-bank-${org.organizationCode}`}
                effect="solid"
                place={'top'}
                padding="4px 8px"
              >
                {org.organizationName}
              </Tooltip>
            </div>
          );
        })}
    </div>
  );
};

export default BankListRenderer;
